import { employmentTypes } from "../../../constants";
import criteria from "../../../utils/criteria";

const { FULL_TIME, PART_TIME, CONTRACT, CASUAL } = employmentTypes;

const {
  termIsBetween,
  assetType,
  loanAmountBetween,
  creditScoreGreaterThan,
  employmentType,
  timeOfEmploymentGreaterThan,
} = criteria;

const midPrime = [
  {
    name: "Mid Prime",
    rate: [15.99, 19.99],
    productType: "Adverse",
    criteria: [
      loanAmountBetween(10000, 50000),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Motorbike",
        "ATV/Off-Road Bike",
        "Tractor",
        "Ride on mower",
        "Horse float",
        "Trailer",
        "Caravan",
        "Motor home",
        "Trailered boat",
        "Jetski/PWC",
      ]),
      termIsBetween(36, 60),
      employmentType([FULL_TIME, PART_TIME, CASUAL, CONTRACT]),
      timeOfEmploymentGreaterThan(1),
      creditScoreGreaterThan(450, 700),
    ],
  },
];
export default midPrime;
